import API from '@/API';
import { generateExpiryToken } from '@/lib/utils';
import axios from 'axios';
import toast from 'react-hot-toast';

export const nextFormDataApi = axios.create({
  baseURL: '/api',
  timeout: 60000,
  headers: {
    Accept:
      'text/html, application/xhtml+xml, application/xml;q=0.9, image/webp',
    'Content-Type': 'multipart/form-data',
    'Cache-Control': 'no-store',
  },
});

export const nextJsonApi = axios.create({
  baseURL: '/api',
  timeout: 600000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-store',
  },
});

export const handleResponse = (response: any) => {
  if (response?.status === 202) {
    toast.error(response.data.error);
    return false;
  } else if (response?.response?.status === 500) {
    toast.error(response?.response?.data?.error);
    return false;
  } else if (response?.response?.status === 400) {
    toast.error(response?.response?.data?.error);
    return false;
  } else if (response?.response?.status === 401) {
    toast.error('You are not authorized for the action.');
    return false;
  } else if (response?.response?.status === 498) {
    toast.error('Session expired. Please login again.');
    localStorage.clear();
    window.location.href = '/';
    return false;
  } else if (response?.status === 200) {
    return response?.data;
  } else if (
    response?.response?.status === 410 ||
    response?.response?.status === 422
  ) {
    toast.error(response?.response?.data?.error);
    return response?.response?.data?.error;
  } else {
    toast.error('Something went wrong. Please contact server admin.');
    return false;
  }
};

export const tokenizeUrl = (url: any) => {
  return url + process.env.NEXT_PUBLIC_API_TOKEN;
};

export const formEncode = (arr: any) => {
  try {
    let bodyFormData = new FormData();
    for (let key of Object.keys(arr)) {
      if (Array.isArray(arr[key])) {
        for (let item of arr[key]) {
          bodyFormData.append(key, item);
        }
      } else if (arr[key] instanceof File) {
        bodyFormData.append(key, arr[key]);
      } else if (arr[key] !== null && arr[key] !== undefined) {
        bodyFormData.append(key, arr[key]);
      }
    }
    return bodyFormData;
  } catch (error) {
    console.log('error', error);
  }
};

export const getToken = async () => {
  const session = localStorage.getItem('userSession')
    ? JSON.parse(localStorage.getItem('userSession') as string)
    : null;
  let response = session?.token;
  if (session && session?.token_expiry - new Date().getTime() < 1) {
    //call refresh token and update client token
    try {
      // const apiresponse =
      await API.auth.refreshToken(session?.user?.admin_id, response);
      // session.token = apiresponse?.data?.token;
      // session.token_expiry = generateExpiryToken();
      // response = session.token;
      // localStorage.setItem('userSession', JSON.stringify(session));
    } catch (e) {
      console.log(e);
    }
  }

  return response;
};
